/* Reuse Dawn's product cards and cart UI; fetch only complementary recommendations. */
if (!customElements.get('rc-complementary')) {
  customElements.define('rc-complementary', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.load();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url, { signal: this.controller.signal, cache: 'no-cache' });
        if (!response.ok) throw new Error(`Recommendations: ${response.status}`);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.getElementById(this.id)?.querySelector('[data-rc-content]');
        if (!content?.querySelector('.rc-complementary__item')) {
          this.hidden = true;
          return;
        }
        this.replaceChildren(content);
        this.hidden = false;
        const track = this.querySelector('.rc-complementary__track');
        const controls = this.querySelector('.rc-complementary__controls');
        const prev = this.querySelector('[data-rc-prev]');
        const next = this.querySelector('[data-rc-next]');
        const counter = this.querySelector('[data-rc-count]');
        const items = Array.from(track.children);
        const rtl = getComputedStyle(track).direction === 'rtl';
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          const position = Math.abs(track.scrollLeft);
          controls.hidden = max < 2;
          prev.disabled = position < 2;
          next.disabled = position >= max - 2;
          const stride = items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
          const first = Math.round(position / stride) + 1;
          const gap = parseFloat(getComputedStyle(track).columnGap);
          const last = Math.min(items.length, Math.max(first, Math.floor((position + track.clientWidth + gap + 2) / stride)));
          counter.textContent = first === last ? `${first} / ${items.length}` : `${first}\u2013${last} / ${items.length}`;
        };
        const scroll = (direction) => track.scrollBy({
          left: direction * (rtl ? -1 : 1) * (items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap)) * Math.max(1, Math.floor((track.clientWidth + 12) / (items[0].getBoundingClientRect().width + 12))),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        prev.addEventListener('click', () => scroll(-1));
        next.addEventListener('click', () => scroll(1));
        track.addEventListener('scroll', update, { passive: true });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      } catch (error) {
        this.hidden = true;
        if (error.name !== 'AbortError') console.warn('Unable to load complementary products.', error);
      }
    }
  });
}
